import { render, staticRenderFns } from "./AcompanhamentoDeEnvio.vue?vue&type=template&id=11af48de"
import script from "./AcompanhamentoDeEnvio.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoDeEnvio.vue?vue&type=script&lang=js"
import style0 from "./AcompanhamentoDeEnvio.vue?vue&type=style&index=0&id=11af48de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports